require("utility/icons/answer_circle.scss");

var AnswerCircle = function(props) {
	var answerIconPath;
	if (props.warmUp) {
		answerIconPath = "quiz-icons/warmup-complete.png";
	} else if (props.fillInTheBlank) {
		// Yeah, this is mis-labelled
		answerIconPath = "quiz-icons/open-ss-complete.png";
	} else if (props.withSentenceStarter) {
		// Yeah, this is mis-labelled
		answerIconPath = "quiz-icons/open-no-ss-complete.png";
	} else {
		answerIconPath = "quiz-icons/open-no-ss-complete.png";
	}

	return (
		<div className="answerCircle">
			<img src={ dynamicRequire(answerIconPath) }
				className="answerIcon" />
		</div>
	);
};

AnswerCircle.propTypes = StrictPropTypes({
	warmUp: PropTypes.bool,
	fillInTheBlank: PropTypes.bool,
	withSentenceStarter: PropTypes.bool,
	openEnded: PropTypes.bool,
});

module.exports = AnswerCircle;



// WEBPACK FOOTER //
// ./modules/components/utility/icons/AnswerCircle.js